import { render, staticRenderFns } from "./AuditPendingNotice.vue?vue&type=template&id=589b16cb&scoped=true"
import script from "./AuditPendingNotice.vue?vue&type=script&lang=js"
export * from "./AuditPendingNotice.vue?vue&type=script&lang=js"
import style0 from "./AuditPendingNotice.vue?vue&type=style&index=0&id=589b16cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589b16cb",
  null
  
)

export default component.exports